import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import store from './store'
import { sync } from 'vuex-router-sync'
import VueApexCharts from 'vue-apexcharts'

import { dateFilter } from 'vue-date-fns'

import VueTheMask from 'vue-the-mask'
import 'vue-advanced-cropper/dist/style.css'
Vue.use(VueTheMask)

Vue.filter('date', dateFilter)

Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

sync(store, router)

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app')
